import React, { useState, useRef } from 'react';
import { Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import { updatePreferences } from '../../../API/Preferences/Preferences';
import { FaSmile } from 'react-icons/fa';

export const WelcomeModal = ({ onClose, content, setContent }: { onClose: () => void, content: string, setContent: (content: string) => void }) => {
    const [loading, setLoading] = useState(false);
    const [showEmojis, setShowEmojis] = useState(false);
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const emojis = ['😊', '😂', '👍', '❤️', '😎', '🎮', '💰', '✨', '🔥', '👋', '😅', '🙏', '💪', '🎯', '🌟',
        '🎁', '💎', '🏆', '💯', '🔔', '📱', '💻', '🎲', '🎯', '🎪', '🎭', '🎨', '🎬', '🎤', '🎧'];

    const handleClose = () => onClose();

    const handleSave = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append('welcomeModalContent', content);
            if (content) {
                await updatePreferences(formData);
                toast.success("Preferencias actualizadas correctamente");
            }
            handleClose();
        } catch (error) {
            toast.error("Error al actualizar las preferencias");
        } finally {
            setLoading(false);
        }
    };

    const insertEmoji = (emoji: string) => {
        if (!textareaRef.current) return;

        const textarea = textareaRef.current;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        const newContent = content.substring(0, start) + emoji + content.substring(end);
        setContent(newContent);

        // Restaurar la posición del cursor después de la inserción
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(start + emoji.length, start + emoji.length);
        }, 0);
    };

    return (
        <Modal show={true} onHide={handleClose} size="lg">
            <Modal.Header closeButton className="bg-darker text-light">
                <Modal.Title>Configurar Modal de Bienvenida</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-darker text-light">
                <Form>
                    <Form.Group className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <Form.Label>Contenido del modal de bienvenida</Form.Label>
                            <Dropdown show={showEmojis} onToggle={(isOpen) => setShowEmojis(isOpen)}>
                                <Dropdown.Toggle
                                    variant="outline-secondary"
                                    className="p-2"
                                    style={{ minWidth: '40px' }}
                                >
                                    <FaSmile className='text-warning' size={20} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="bg-dark p-2" style={{ maxWidth: '300px' }}>
                                    <div className="d-flex flex-wrap gap-2">
                                        {emojis.map((emoji, index) => (
                                            <span
                                                key={index}
                                                role="button"
                                                onClick={() => insertEmoji(emoji)}
                                                style={{ fontSize: '20px', cursor: 'pointer' }}
                                            >
                                                {emoji}
                                            </span>
                                        ))}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <textarea
                            ref={textareaRef}
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            className="w-100 h-100 form-control bg-darker text-light"
                            style={{ minHeight: '600px' }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="bg-darker text-light">
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={loading}>
                    {loading ? 'Guardando...' : 'Guardar Contenido'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
